import './NoPage.css';

const NoPage = () => {
    return (
        <div className="no-page-container">
            <h1 className="no-page-title">404</h1>
            <p className="no-page-message">Oops! The page you're looking for doesn't exist.</p>
        </div>
    );
};

export default NoPage;